export const router = [{
  path: 'noPermission',
  component: resolve => require(['./index.vue'], resolve)
}]
